const NewBudgetPopupBody = ({message, children}) =>  {

    return (
        <p>New Budget</p>
    );
  
};

export default NewBudgetPopupBody;